import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type DisclosureModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function DisclosureModal({ isOpen, onClose }: DisclosureModalProps) {
  const { t } = useTranslation('common');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-3xl max-h-[90vh] w-full relative">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white rounded-t-xl">
          <h2 className="text-xl font-bold text-gray-900">{t('disclosureModal.title')}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label={t('disclosureModal.closeLabel')}
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
          <div className="prose prose-sm max-w-none space-y-4">
            <p>{t('disclosureModal.paragraph1')}</p>
            <p>{t('disclosureModal.paragraph2')}</p>
            <p>{t('disclosureModal.paragraph3')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
